import { render, staticRenderFns } from "./AddInboxDialog.vue?vue&type=template&id=4bde4d30&scoped=true"
import script from "./AddInboxDialog.vue?vue&type=script&lang=js"
export * from "./AddInboxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bde4d30",
  null
  
)

export default component.exports